import { Typography, TypographyProps } from '@material-ui/core';
import styledFuncs from 'app/styles/styledFuncs';
import React from 'react';
import { css } from 'styled-components/macro';

type Props = {
  children: React.ReactNode;
  className?: string;
  component?: 'p' | 'div' | 'ol';
  centered?: boolean;
  withNext?: boolean;
  tiny?: boolean;
  small?: boolean;
  bold?: boolean;
  antiMargin?: boolean;
} & TypographyProps;

export default function Body({
  children,
  className,
  component = 'p',
  centered,
  withNext,
  small,
  tiny,
  bold,
  antiMargin,
  ...props
}: Props): JSX.Element {
  const textSize = tiny ? 'tiny' : small ? 'small' : 'normal';
  return (
    <Typography
      variant="body1"
      css={css`
        ${centered !== undefined &&
        css`
          align-self: ${centered ? 'center' : 'flex-start'};
          text-align: ${centered ? 'center' : 'start'};
        `};
        ${withNext &&
        css`
          // NOTE: !important is to override the margin applied from
          // ViewFrame / Form, and is simpler than trying to use a
          // className since only the bottom margin needs to be 0
          margin-bottom: 0 !important;
        `}
        ${antiMargin &&
        css`
          margin-left: ${styledFuncs.pad(-1)};
          margin-right: ${styledFuncs.pad(-1)};
        `}
        font-weight: ${bold ? 600 : 500};
        font-size: ${styledFuncs.pxToRem(
          { tiny: 12, small: 14, normal: 16 }[textSize]
        )};
      `}
      {...{ className, component }}
      {...props}
    >
      {children}
    </Typography>
  );
}
